import { BuiltInFontDefinition, BuiltInFonts } from "../fonts/BuiltInFonts";
import { BuiltInIntuitiveFonts } from "../fonts/IntuitiveFonts";
import { BuiltInMerckFonts } from "../fonts/MerckFonts";
import { BuiltInMicrosoftFonts } from "../fonts/MicrosoftFonts";
import { BuiltInPremiseHealthFonts } from "../fonts/PremiseHealthFonts";
import { BuiltInSantanderFonts } from "../fonts/SantanderFonts";
import { BuiltInVerizonFonts } from "../fonts/VerizonFonts";
import { BuiltInZendeskFonts } from "../fonts/ZendeskFonts";
import { BuiltInComcastFonts } from "../fonts/ComcastFonts";
import { BuiltInInternationalRescueCommitteeFonts } from "../fonts/InternationalRescueCommitteeFonts";
import { BuiltInRTXFonts } from "../fonts/RTXFonts";
import { BuiltInTargetFonts } from "../fonts/TargetFonts";

const getOrganizationSelectOptionsFonts = (organization: string, filterFont = false) => {
  let fonts: BuiltInFontDefinition[] = BuiltInFonts.map(
    font => ({ ...font, label: font.family, value: font.family })
  );

  // Comcast fonts
  if (organization === "Comcast") {
    let comcastFonts = BuiltInComcastFonts;
    comcastFonts = comcastFonts.map(font => ({ ...font, label: `${font.family} (${font.styles[0]})`, value: font.family }));
    fonts = [...comcastFonts, ...fonts];
    if (filterFont) fonts = fonts.filter(font => font.family.includes("Comcast New Vision"));
  }

  // Verizon fonts
  if (organization === "Verizon" && fonts[0].family !== "Verizon NHG DS") {
    let verizonFonts = BuiltInVerizonFonts;
    verizonFonts = verizonFonts.map(font => ({ ...font, label: `${font.family} (${font.styles[0]})`, value: font.family }));
    fonts = [...verizonFonts, ...fonts];
  }

  // Microsoft fonts
  if (organization === "Microsoft" && fonts[0].family !== "Verizon NHG DS") {
    let microsoftFonts = BuiltInMicrosoftFonts;
    microsoftFonts = microsoftFonts.map(font => ({ ...font, label: `${font.family} (${font.styles[0]})`, value: font.family }));
    fonts = [...microsoftFonts, ...fonts];
  }

  // Merck MSD fonts
  if ((organization === "Merck" || organization === "MSD") && fonts[0].family !== "Invention App Regular") {
    let merckFonts = BuiltInMerckFonts;
    merckFonts = merckFonts.map(font => ({ ...font, label: `${font.family} (${font.styles[0]})`, value: font.family }));
    fonts = [...merckFonts, ...fonts];
  }

  // Intuitive fonts
  if (organization === "Intuitive" && fonts[0].family !== "Brown Regular") {
    let intuitiveFonts = BuiltInIntuitiveFonts;
    intuitiveFonts = intuitiveFonts.map(font => ({ ...font, label: `${font.family} (${font.styles[0]})`, value: font.family }));
    fonts = [...intuitiveFonts, ...fonts];
  }

  // Zendesk fonts
  if ((organization === "Zendesk" || organization === "Zendesk Working Space") && fonts[0].family !== "FeatureText-Regular-Web") {
    let zendeskFonts = BuiltInZendeskFonts;
    zendeskFonts = zendeskFonts.map(font => ({ ...font, label: `${font.family} (${font.styles[0]})`, value: font.family }));
    fonts = [...zendeskFonts, ...fonts];
  }

  // Santander fonts
  if ((organization === "Santander" || organization === "Santander Private Space") && fonts[0].family !== "Santander Text Regular") {
    let santanderFonts = BuiltInSantanderFonts;
    santanderFonts = santanderFonts.map(font => ({ ...font, label: `${font.family} (${font.styles[0]})`, value: font.family }));
    fonts = [...santanderFonts, ...fonts];
  }

  // Premise Health fonts
  if (organization === "Premise Health") {
    let premiseHealthFonts = BuiltInPremiseHealthFonts;
    premiseHealthFonts = premiseHealthFonts.map(font => ({ ...font, label: `${font.family} (${font.styles[0]})`, value: font.family }));
    fonts = [...premiseHealthFonts, ...fonts];
  }

  // Synopsys exception
  if (organization === "Synopsys" || organization === "Synopsys Private Workspace") {
    fonts = fonts.filter(font => font.family === "Roboto");
  }

  // International Rescue Committee fonts
  if (organization === "International Rescue Committee") {
    let ircFonts = BuiltInInternationalRescueCommitteeFonts;
    ircFonts = ircFonts.map(font => ({ ...font, label: `${font.family} (${font.styles[0]})`, value: font.family }));
    fonts = [...ircFonts, ...fonts];
  }

  // RTX fonts
  if (organization === "RTX") {
    let rtxFonts = BuiltInRTXFonts;
    rtxFonts = rtxFonts.map(font => ({ ...font, label: `${font.family} (${font.styles[0]})`, value: font.family }));
    fonts = rtxFonts;
  }

  // Target fonts
  if (organization === "Target") {
    let targetFonts = BuiltInTargetFonts;
    targetFonts = targetFonts.map(font => ({ ...font, label: `${font.family} (${font.styles[0]})`, value: font.family }));
    fonts = targetFonts;
  }

  return fonts;
};

export default getOrganizationSelectOptionsFonts;
